import { render, staticRenderFns } from "./NossasEntregas.vue?vue&type=template&id=59df88b1&"
import script from "./NossasEntregas.vue?vue&type=script&lang=js&"
export * from "./NossasEntregas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports